import React, { useEffect, useState } from "react";
import { Row, Col, CardBody, Button } from "reactstrap";
import AggregateResourceCarousel from "./AggregateResource";
import logoLarge from '../../assets/images/users/user-dummy-img.jpg';
import { useDispatch, useSelector } from "react-redux";
import { viewDoc } from "../../slices/customer/documentview/thunk";
import { useNavigate } from "react-router-dom";
import CommonButton from "../Utils/CommonButton";

export const Profile = ({ customerPermission, customerData, fetchCustomerSummaryData, formatDate }) => {
    const dispatch = useDispatch();
    const [profileImage, setProfileImage] = useState(logoLarge);
    const [loading, setLoading] = useState(false);
    const [profileData, setProfileData] = useState(false);
    const [aggregateResourceLength, setAggregateResourceLength] = useState(0);
    const navigate = useNavigate();
    useEffect(() => {
        if (customerData?.customerInfo?.userName) {
            const partnerOrCustomer = "Customer";
            dispatch(viewDoc(setLoading, customerData.customerInfo.customerId, "logo", partnerOrCustomer, setProfileData));
        }
    }, [dispatch, customerData]);

    const ViewDocument = useSelector(state => state.ViewDocument.documentView);
    const base64ImageData = ViewDocument?.filePath;
    const customer = customerData?.customerInfo || {};
    const aggregateResources = fetchCustomerSummaryData?.resources?.filter(
        resource => resource.isAggregate
    ) || [];
    useEffect(() => {
        setProfileImage(base64ImageData || logoLarge);
    }, [base64ImageData]);

    const renderDoubleColumnRow = (leftLabel, leftValue, rightLabel, rightValue, noBorder = false) => {
        const formatValue = (label, value) => {
            if (!label) return '';
            return value ? value : 'N/A';
        };

        return (
            <div className={`d-flex mb-3 pb-2 ${noBorder ? '' : 'border-bottom'}`}>
                <div className="w-50 pe-3">
                    {leftLabel && <label className="fw-semibold">{leftLabel}</label>}
                    <p className="detail-value mb-0">{formatValue(leftLabel, leftValue)}</p>
                </div>
                <div className="w-50 ps-3">
                    {rightLabel && <label className="fw-semibold">{rightLabel}</label>}
                    <p className="detail-value mb-0">{formatValue(rightLabel, rightValue)}</p>
                </div>
            </div>
        );
    };

    return (
        <div className="customer-profile-container py-2">
            <Row className="justify-content-center">
                <Col lg={10}>
                    <div className="rounded-1 px-3 py-3 my-2 bg-white">
                        <CardBody>
                            <div className="d-flex align-items-center mb-4">
                                <div className="profile-image-container me-4">
                                    <img
                                        src={profileImage}
                                        className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                                        alt="user-profile"
                                        style={{ width: '110px', height: '110px', objectFit: 'cover' }}
                                    />
                                </div>
                                <div >
                                    <h4 className="mb-1 fw-bold text-black">{customer?.userName || 'N/A'}</h4>
                                    <p className="text-muted mb-0">{customer.customerId || 'N/A'}</p>
                                </div>
                                {customerPermission && customerPermission?.has("update") &&
                                <div className="ms-auto mt-n5">
                                    <CommonButton
                                        color={"main-color"}
                                        className={
                                            "btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap mt-n4"
                                        }
                                        icon={
                                            <i className="bx bxs-edit label-icon align-middle fs-16 me-1"></i>
                                        }
                                        btnTxtClsName={"px-2 ps-1 ms-3 me-1"}
                                        type={"submit"}
                                        buttonAction={() => {
                                            navigate(`/update-customer/${customer.customerId}`)
                                        }}
                                        buttonText={'Edit'}
                                    />
                                </div>}
                            </div>
                            <div className="profile-details-section">
                                <p className="fs-5 fw-semibold mb-3 pb-2 border-bottom">Personal Details</p>
                                {renderDoubleColumnRow("First Name", customer.firstName, "Last Name", customer.lastName)}
                                {renderDoubleColumnRow("Account Number", customer.customerId, "Email", customer.email)}
                                {renderDoubleColumnRow("Phone Number", `${customer.dialCode || ''} ${customer.mobile || ''}`, "", "", true)}
                                <p className="fs-5 fw-semibold mt-4 mb-3 pb-2 border-bottom">Address</p>
                                {renderDoubleColumnRow("Address 1", customer.addressLine1, "Address 2", customer.addressLine2)}
                                {renderDoubleColumnRow("City", customer.city, "State", customer.state)}
                                {renderDoubleColumnRow("Country", customer.country, "Zip Code", customer.zipCode, true)}
                            </div>
                            {aggregateResources.length > 0 && (
                                <div className="mt-4">
                                    <p className="fs-5 fw-semibold mb-3 border-bottom">Aggregate Balance View</p>
                                    <div className="balance-display" style={{ backgroundColor: '#E8EDF5', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                                        <AggregateResourceCarousel resources={aggregateResources} />
                                    </div>
                                </div>
                            )}
                        </CardBody>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default Profile;